import { createAsyncThunk } from "@reduxjs/toolkit";
import { menuSubcategoriesService } from "service/menuSubcategoriesService";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";

export const getSubcategoryById = createAsyncThunk(
  "menuSubcategories/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await menuSubcategoriesService.getSubcategoryById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const createSubcategory = createAsyncThunk(
  "menuSubcategories/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await menuSubcategoriesService.createSubcategory(data);
      Notify(NOTIFY.type.success, NOTIFY.message.add);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateSubcategory = createAsyncThunk(
  "menuSubcategories/update",
  async ({ id, name, categoryId }, { rejectWithValue }) => {
    try {
      const response = await menuSubcategoriesService.updateSubcategory(id, {
        name,
        categoryId,
      });
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteSubcategory = createAsyncThunk(
  "menuSubcategories/delete",
  async (id, { rejectWithValue }) => {
    try {
      await menuSubcategoriesService.deleteSubcategory(id);
      Notify(NOTIFY.type.success, NOTIFY.message.delete);
      return id;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const reorderSubcategories = createAsyncThunk(
  "menuSubcategories/reorder",
  async ({ categoryId, subcategoryIds }, { rejectWithValue }) => {
    try {
      const response = await menuSubcategoriesService.reorderSubcategories({
        categoryId,
        subcategoryIds,
      });
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      return response.data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
